import { zodResolver } from "@hookform/resolvers/zod";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { usePdfViewerContext } from "@src/appV2/PdfViewer/context";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const signAgreementFormSchema = z.object({
  confirmation: z.boolean().refine((value) => value, {
    message: "Click the checkbox to confirm and proceed.",
  }),
  agreementScrolled: z.boolean().refine((value) => value, {
    message: "You must read the full agreement by scrolling to the bottom to proceed.",
  }),
});

export type SignAgreementFormValues = z.infer<typeof signAgreementFormSchema>;

export function useICAgreementForm() {
  const formMethods = useForm({
    defaultValues: {
      confirmation: false,
      agreementScrolled: false,
    },
    mode: "all",
    resolver: zodResolver(signAgreementFormSchema),
  });

  const { setValue, trigger } = formMethods;

  const { currentPage, numberOfPages, isSupportedPlatform } = usePdfViewerContext();

  useEffect(() => {
    void trigger();
  }, [trigger]);

  useEffect(() => {
    if (currentPage === numberOfPages || isSupportedPlatform === false) {
      setValue("agreementScrolled", true, { shouldValidate: true });
    }
  }, [currentPage, numberOfPages, isSupportedPlatform, setValue]);

  useLogEffect(APP_V2_APP_EVENTS.PDF_PLATFORM_UNSUPPORTED_ONBOARDING, undefined, {
    enabled: isSupportedPlatform === false,
  });

  return {
    formMethods,
  };
}
